import _ from 'lodash'
import md5 from 'js-md5'
import {API} from '@/util/api'
import {requestByPost} from '../../util/request'
import {ucBackstageUrl} from '../../config/project-config'
import store from '../../store'
import axios from 'axios'
import qs from 'qs'

/**
 * 用户模块
 */
export default {
  // namespaced: true 的方式使其成为带命名空间的模块。保证在变量名一样的时候，添加一个父级名拼接
  namespaced: true,
  state: {
    // 这里放全局参数
    token: '' // token
  },
  getters: {
    // 这里放get方法 this.$store.getters['user/getUserId']
    getToken() { // 生成token
      let rod = Math.floor(Math.random() * 999999)
      let token = md5(rod + 'xtzz')
      return token
    }
  },
  mutations: {
    // 这里是set方法  this.$store.commit('setDemoValue', value);
  },
  actions: {
    saveUcQuotationAi({ commit }, data) { // 登录
      return requestByPost(API.saveUcQuotationAi, data)
    },
    exportUcQuotationExcelAi ({ commit }, data) {
      // return requestByPost(API.exportUcQuotationExcelAi, data)
      let timestamp = new Date().getTime() + '';
      let radom = Math.random() + '';
      let str = timestamp + radom + '1'
      let token = md5(str)
      return new Promise((resolve, reject) => {
        return axios({
          method: 'post',
          url: ucBackstageUrl + '/' + API.exportUcQuotationExcelAi,
          data: qs.stringify({in: data}),
          headers: {		//请求头的信息
            'Access-Control-Allow-Origin': '*',
            'timestamp': timestamp,
            'radom': radom,
            'crossToken': token,
            'crossType': 1
          },
          responseType: 'blob'
        }).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/quotation.js